export var DbRef;
(function (DbRef) {
    DbRef["BARCODES"] = "supplies/barcodes";
    DbRef["BATCH_ITEMS"] = "supplies/batchItems";
    DbRef["BATCH_SKUS"] = "supplies/batchSkus";
    DbRef["BOOKINGS"] = "bookings";
    /** @deprecated */
    DbRef["BOOKING_EVENTS"] = "bookingEvents";
    /** `CloudVariables.fetchWithRelationshipsMeta` */
    DbRef["CLOUD_FETCH_WITH_RELATIONSHIPS_META"] = "cloudVariables/fetchWithRelationshipsMeta";
    DbRef["DRAFT_WAYPOINTS"] = "draftWaypoints";
    DbRef["FEATURE_FLAGS"] = "variables/featureFlags";
    DbRef["FEEDBACK"] = "feedback";
    /** Miscellaneous files uploaded via `/files` on Dashboard */
    DbRef["FILES"] = "files";
    DbRef["FRIDAY_BRICK_AND_MORTAR_CUTOFF_TIME"] = "variables/fridayBrickAndMortarCutoffTime";
    DbRef["FULFILLMENT_INTEGRATIONS"] = "variables/fulfillmentIntegrations";
    DbRef["HASHED_CONFIGURATIONS"] = "hashedConfigurations";
    DbRef["HISTORY"] = "history";
    DbRef["HISTORY_ITINERARIES"] = "history/itineraries";
    DbRef["ICD_10_CODES"] = "icd10Codes";
    DbRef["INSURANCE_PROVIDERS"] = "insuranceProviders";
    DbRef["INTERVIEW_CRITERIA"] = "variables/interviewQualities";
    DbRef["ITINERARIES"] = "itineraries";
    DbRef["MEDICAL_TITLES"] = "variables/medicalTitles";
    DbRef["NOTES"] = "notes";
    DbRef["OFFICES"] = "offices";
    DbRef["ORDERS"] = "orders";
    DbRef["PLACES"] = "places/places";
    DbRef["PLACE_ACCOUNTS"] = "places/placeAccounts";
    DbRef["PLACE_GROUPS"] = "places/placeGroups";
    DbRef["PLACE_GROUP_TYPES"] = "places/placeGroupTypes";
    DbRef["POLYGONS"] = "polygons";
    DbRef["POLYGONS_BY_SERVICE_REGION"] = "polygons/serviceRegions";
    DbRef["CARE_SEND_PRICING_INFO"] = "variables/caresendPricingInfo";
    DbRef["PROCEDURES"] = "procedures";
    DbRef["PROCESSING_QUEUE_ITEMS"] = "processingQueue/items";
    DbRef["PROCESSING_QUEUE_ITEMS_CONFIRMED"] = "processingQueue/itemsConfirmed";
    DbRef["PRODUCTS"] = "variables/products";
    DbRef["RECRUITMENT_FILTERS"] = "variables/recruitmentFilters";
    DbRef["REPORTING"] = "reporting";
    DbRef["SCHEDULING_CONFIG"] = "variables/schedulingConfig";
    DbRef["SERVICE_GEOHASHES"] = "serviceGeohashes";
    DbRef["SERVICE_REGIONS"] = "variables/serviceRegions";
    DbRef["SERVICE_REGION_GROUPS"] = "variables/serviceRegionGroups";
    DbRef["SHIFTS"] = "shifts";
    DbRef["SHIPMENTS"] = "supplies/shipments";
    DbRef["SKUS"] = "supplies/skus";
    DbRef["SUPPLIES"] = "variables/supplies";
    DbRef["SUPPLY_CONFIGURATIONS"] = "hashedConfigurations/supplies";
    /**
     * `ByID<SupplyInstructionConfigOptions>` by procedure ID. Once a draft waypoint
     * is finalized the selected `SupplyInstructionConfiguration` is copied into
     * the procedure.
     */
    DbRef["SUPPLY_INSTRUCTION_CONFIG_OPTIONS"] = "supplies/supplyInstructionConfigOptions";
    DbRef["SUPPLY_ITEMS"] = "supplies/supplyItems";
    DbRef["SUPPLY_TRANSFERS"] = "supplies/supplyTransfers";
    DbRef["TASKS"] = "variables/tasks";
    DbRef["TASK_TYPES"] = "variables/taskTypes";
    DbRef["TEST"] = "test";
    DbRef["TIME_SLOTS"] = "timeSlots";
    DbRef["TIME_SLOTS_BY_SERVICE_REGION"] = "timeSlots/timeSlotsByServiceRegion";
    DbRef["LAB_SHIPMENT_INFO_BY_SERVICE_REGION_GROUP"] = "timeSlots/labShipmentInfoByServiceRegionGroup";
    DbRef["PATIENT_SHIPMENT_INFO_BY_SERVICE_REGION_GROUP"] = "timeSlots/patientShipmentInfoByServiceRegionGroup";
    DbRef["PLACES_BY_SERVICE_REGION"] = "timeSlots/placesByServiceRegion";
    DbRef["TIME_SLOTS_META"] = "cloudVariables/timeSlotsMeta";
    DbRef["TIME_SLOTS_MODEL_RUN"] = "cloudVariables/timeSlotsMeta/modelRun";
    DbRef["TIME_SLOT_BLOCKING"] = "cloudVariables/timeSlotsMeta/timeSlotBlocking";
    DbRef["TRANSACTIONS"] = "transactions";
    DbRef["USERS"] = "users";
    DbRef["VARIABLES"] = "variables";
    DbRef["WAYPOINTS"] = "waypoints";
    DbRef["WAYPOINT_ACTIONS"] = "waypointActions";
})(DbRef || (DbRef = {}));
export var StorageRef;
(function (StorageRef) {
    StorageRef["BACKGROUND_CHECKS"] = "backgroundChecks";
    StorageRef["CHARTING"] = "charting";
    StorageRef["DATABASE_SCRIPT_CSVS"] = "databaseScriptsCSVs";
    /** Miscellaneous files uploaded via `/files` on Dashboard */
    StorageRef["FILES"] = "files";
    StorageRef["GENERIC_DOCUMENTS"] = "genericDocuments";
    StorageRef["ID_VERIFICATION_PICTURES"] = "idVerificationPictures";
    StorageRef["LAB_RESULTS"] = "labResults";
    StorageRef["LICENSES"] = "licenses";
    StorageRef["MAIL_IN_SHIPPING_LABELS"] = "shippingLabels/mailIn";
    StorageRef["NOTE_FILES"] = "noteFiles";
    StorageRef["ORDER_FILES"] = "orderFiles";
    StorageRef["PLACE_GROUP_LOGOS"] = "placeGroupLogos";
    StorageRef["PROCEDURE_INSTRUCTIONS"] = "procedureInstructions";
    StorageRef["PROFILE_PICTURES"] = "profilePictures";
    StorageRef["REQUISITION_FORMS"] = "requisitionForms";
    StorageRef["RESULTS"] = "results";
    StorageRef["SHIPPING_LABELS"] = "shippingLabels";
    StorageRef["SHIPMENT_MANIFESTS"] = "shipmentManifests";
    StorageRef["USERS"] = "users";
})(StorageRef || (StorageRef = {}));
//# sourceMappingURL=firebase.js.map